import BaseSVG, { BaseSVGProps } from '../BaseSVG'

export const BrowserCodeIcon = (props: BaseSVGProps) => {
  return (
    <BaseSVG viewBox="0 0 18 18" {...props} fill="none">
      <path
        d="M15.7363 1.04114H2.26742C1.59118 1.04114 1.04297 1.58935 1.04297 2.26559V15.7345C1.04297 16.4108 1.59118 16.959 2.26742 16.959H15.7363C16.4126 16.959 16.9608 16.4108 16.9608 15.7345V2.26559C16.9608 1.58935 16.4126 1.04114 15.7363 1.04114Z"
        strokeWidth="1.42917"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M1.04297 4.3573H16.961" strokeWidth="1.42917" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M7.01317 9L5.02344 10.9897L7.01317 12.9795"
        strokeWidth="1.42917"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9922 9L12.9819 10.9897L10.9922 12.9795"
        strokeWidth="1.42917"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseSVG>
  )
}
